import * as yup from 'yup';

export const systemParametersValidations = yup.object({
  booking_fee_percentage: yup
    .number('Enter the booking fee percentage')
    .required('Booking fee percentage is required')
    .min(0, 'Booking fee must be greater than or equal to 0')
    .max(100, 'Booking fee must be less than or equal to 100'),
  cancellation_fee_percentage: yup
    .number('Enter the cancellation fee percentage')
    .required('Cancellation fee percentage is required')
    .min(0, 'Cancellation fee must be greater than or equal to 0')
    .max(100, 'Cancellation fee must be less than or equal to 100'),
  retail_booking_fee_percentage: yup
    .number('Enter the retail booking fee percentage')
    .required('Retail booking fee percentage is required')
    .min(0, 'Retail booking fee must be greater than or equal to 0')
    .max(100, 'Retail booking fee must be less than or equal to 100'),
  retail_cancellation_fee_percentage: yup
    .number('Enter the retail cancellation fee percentage')
    .required('Retail cancellation fee percentage is required')
    .min(0, 'Retail cancellation fee must be greater than or equal to 0')
    .max(100, 'Retail cancellation fee must be less than or equal to 100'),
});
